import { NavLink } from "react-router-dom";
import { Icon } from "@mmm/ui";
interface SidebarNavItemProps {
  to: string;
  icon: string;
  label: string;
  end?: boolean;
}

export function SidebarNavItem({ to, icon, label, end = false }: SidebarNavItemProps) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) => `mmm-sidebar-nav-item ${isActive ? "is-active" : ""}`.trim()}
      title={label}
    >
      <Icon name={icon} strokeWidth={1.9} />
      <span>{label}</span>
    </NavLink>
  );
}
